// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Ij-z","breadcrumbItem":"Jj-z"};